import React, { useEffect, useState } from "react";

const NoSsr = ({ children }: { children: React.ReactNode }) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return <>{isHydrated ? <div>{children}</div> : <></>}</>;
};

export { NoSsr };
